import { useQuery } from '@tanstack/react-query'
import { categoryTypes } from '@opallabs/api/v3'
import {
  workspaceCategoryTypesQueryHelper,
  type WorkspaceCategoryTypesQueryHelperTypes,
} from './queryCache'
import { type ClientCategoryTypesDocument } from './types'

export const readWorkspaceCategoryTypesQuery = (
  queryKeyParams: WorkspaceCategoryTypesQueryHelperTypes['QueryKeyParams']
) => ({
  queryKey: workspaceCategoryTypesQueryHelper.makeQueryKey(queryKeyParams),
  queryFn: () =>
    categoryTypes.readCollection({
      params: { query: { filter: queryKeyParams, include: ['custom_fields'] } },
    }),
})

type UseWorkspaceCategoryTypesArgs<
  TSelectorData = WorkspaceCategoryTypesQueryHelperTypes['CacheData'],
> = {
  queryKeyParams: WorkspaceCategoryTypesQueryHelperTypes['QueryKeyParams']
  select?: (
    data: WorkspaceCategoryTypesQueryHelperTypes['CacheData']
  ) => TSelectorData
  enabled?: boolean
}

export const useWorkspaceCategoryTypes = <T = ClientCategoryTypesDocument>({
  queryKeyParams,
  select,
  enabled,
}: UseWorkspaceCategoryTypesArgs<T>) => {
  return useQuery({
    ...readWorkspaceCategoryTypesQuery(queryKeyParams),
    select,
    enabled,
  })
}
